import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { brand } from '../config/brand';
import { pendingInvite, pendingPlanInvite } from '../features/invites/pendingInvite';
import { AUTHORIZE_PATH, pendingAuthorize } from '../features/oauth/pendingAuthorize';

const ProtectedRoute: React.FC = () => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  // New writers set up their profile before anything else.
  if (user.needsOnboarding && !location.pathname.startsWith(brand.onboardingRoute)) {
    return <Navigate to={brand.onboardingRoute} replace />;
  }

  // An invite link opened while signed out picks up where it left off.
  // Onboarding comes first; the invite waits until it is done.
  const onboarding = location.pathname.startsWith(brand.onboardingRoute);
  const invite = onboarding ? null : pendingInvite();
  if (invite) return <Navigate to={`/invite/${invite}`} replace />;
  const planInvite = onboarding ? null : pendingPlanInvite();
  if (planInvite) return <Navigate to={`/join/${planInvite}`} replace />;
  // Likewise an app's request to connect (MCP over OAuth).
  const authorize = onboarding ? null : pendingAuthorize();
  if (authorize) return <Navigate to={`${AUTHORIZE_PATH}${authorize}`} replace />;

  return <Outlet />;
};

export default ProtectedRoute;
